// Importing Components
import { FormElems, ConditionalComponent, Alert } from 'components';

// Importing Actions
import {
    validateChargeBackRequest,
    resetFindTransactionForm,
    resetRaiseChargebackForm,
} from '../../containers/Chargeback/redux/chargeback.actions';

// Importing Validators
import { findTransactionFormValidator } from './validators';

// Importing Constants
import { CHARGEBACK_SEARCH_OPTIONS } from './constant';

// Importing Libraries
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, reset } from 'redux-form';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';

import './findTransactionForm.scss';

const FindTransactionForm = ({
    handleSubmit,
    formData,
    onSuccess,
    onCancel,
    actions,
    chargebackStoreData,
}) => {
    const { selectedTransactionDetails } = chargebackStoreData;

    useEffect(() => {
        if (selectedTransactionDetails?.isSuccess) {
            onSuccess(selectedTransactionDetails);
        }

        return () => {
            actions.resetFindTransactionForm();
            actions.resetRaiseChargebackForm();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedTransactionDetails?.isSuccess]);

    const handleFindTransactionFormSubmit = values => {
        actions.validateChargeBackRequest({
            criteria: {
                type: values.searchParameter,
                identifier: values.identifier,
            },
        });
    };

    return (
        <form
            className="find-transaction-form"
            onSubmit={handleSubmit(handleFindTransactionFormSubmit)}
        >
            <div className="form-field">
                <Field
                    name="searchParameter"
                    id="searchParameter"
                    component={FormElems.Select}
                    labelField="label"
                    valueField="value"
                    data={CHARGEBACK_SEARCH_OPTIONS}
                />
            </div>
            <div className="form-field">
                <Field
                    labelText="Transaction Id"
                    name="identifier"
                    id="identifier"
                    type="text"
                    component={FormElems.LabelInput}
                />
            </div>

            <ConditionalComponent
                isVisible={
                    selectedTransactionDetails &&
                    selectedTransactionDetails?.error &&
                    selectedTransactionDetails?.error?.errorMessage
                }
            >
                <Alert customClass="error-msg">
                    {selectedTransactionDetails?.error?.errorMessage}
                </Alert>
            </ConditionalComponent>

            <div className="form-section-actions">
                <FormElems.Button
                    buttonType="secondary"
                    id="back-btn"
                    text="Cancel"
                    type="button"
                    handleClick={onCancel}
                    customClass="back-btn"
                />
                <FormElems.Button
                    id="next-btn"
                    buttonType="primary"
                    text="Submit"
                />
            </div>
        </form>
    );
};

const mapStateToProps = ({ form, chargebackData }) => ({
    formData: form['find-transaction-form'],
    chargebackStoreData: chargebackData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            validateChargeBackRequest,
            resetFindTransactionForm,
            resetRaiseChargebackForm,
        },
        dispatch
    ),
});

export default compose(
    reduxForm({
        form: 'find-transaction-form',
        enableReinitialize: true,
        validate: findTransactionFormValidator,
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(FindTransactionForm);

// PropType validation for UpdateChargeBackStatusForm component
FindTransactionForm.propTypes = {
    formData: PropTypes.object,
    chargebackStoreData: PropTypes.object,
    actions: PropTypes.object,
    onSuccess: PropTypes.func,
    onCancel: PropTypes.func,
    handleSubmit: PropTypes.func,
};
